import { normalizeNumber, numberEquals, toNumber } from "./filterUtils";

export function emptyWheelFilters() {
  return {
    tootja: "",
    mudel: "",
    laius: "",
    diameeter: "",
    kinnitus: "",
    etMin: "",
    etMax: "",
    tsentriava: "",
    tüübid: [],
  };
}

// The API only filters wheels by brand and size; the rest is matched locally.
export function buildWheelQuery(filters) {
  const params = new URLSearchParams();

  if (filters.tootja) {
    params.set("BrandName", filters.tootja);
  }

  const width = normalizeNumber(filters.laius);
  if (width !== null) params.set("Width", width);

  const diameter = normalizeNumber(filters.diameeter);
  if (diameter !== null) params.set("Diameter", diameter);

  return params.toString();
}

// "5x112", "5×114,3", "5/112" or "5 112" → { bolts: 5, circle: 112 }
export function parseBoltPattern(value) {
  if (!value) return null;
  const match = String(value)
    .trim()
    .replace(",", ".")
    .match(/^(\d{1,2})\s*[x×*/\s]\s*(\d{2,3}(?:\.\d+)?)$/i);
  if (!match) return null;
  return { bolts: Number(match[1]), circle: Number(match[2]) };
}

export function createWheelMatcher(filters) {
  const model = (filters.mudel || "").trim().toLowerCase();
  const width = normalizeNumber(filters.laius);
  const diameter = normalizeNumber(filters.diameeter);
  const boltPattern = parseBoltPattern(filters.kinnitus);
  const etMin = toNumber(filters.etMin);
  const etMax = toNumber(filters.etMax);
  const centerBore = toNumber(filters.tsentriava);
  const types = filters.tüübid || [];

  return (article) => {
    if (filters.tootja && article?.BrandName !== filters.tootja) return false;

    if (
      model &&
      !(article?.PatternModelText || "").toLowerCase().includes(model)
    ) {
      return false;
    }

    if (width !== null && !numberEquals(width, article?.Width)) return false;
    if (diameter !== null && !numberEquals(diameter, article?.Diameter)) {
      return false;
    }

    if (boltPattern) {
      if (Number(article?.NumberOfBolts) !== boltPattern.bolts) return false;
      if (!numberEquals(boltPattern.circle, article?.BoltCircle)) return false;
    }

    if (etMin !== null || etMax !== null) {
      const offset = toNumber(article?.Offset);
      if (offset === null) return false;
      if (etMin !== null && offset < etMin) return false;
      if (etMax !== null && offset > etMax) return false;
    }

    // A wheel with a larger centre bore still fits using a centring ring,
    // so the filter keeps everything at or above the entered size.
    if (centerBore !== null) {
      const bore = toNumber(article?.CenterBore);
      if (bore === null || bore < centerBore - 0.01) return false;
    }

    if (types.length && !types.includes(Number(article?.MainGroupId))) {
      return false;
    }

    return true;
  };
}
